import * as Dtos from '../../dtos/Tmd.dtos';

export const
    SetUpdateModalState: ITrialInstitutionItemCustomViewDataEntryPageSetUpdateModalStateActionCreator = (updateModalOpen, updateModalCustomDataEntryColumn, updateModalCollectionInstanceData) => {
        return {
            type: ACTION_TRIALINSTITUTIONITEMCUSTOMVIEWDATAENTRY_PAGE_SET_UPDATE_MODAL_STATE,
            updateModalOpen,
            updateModalCustomDataEntryColumn,
            updateModalCollectionInstanceData
        }
    }

export const
    ACTION_TRIALINSTITUTIONITEMCUSTOMVIEWDATAENTRY_PAGE_SET_UPDATE_MODAL_STATE = "ACTION_TRIALINSTITUTIONITEMCUSTOMVIEWDATAENTRY_PAGE_SET_UPDATE_MODAL_STATE"

/* Actions */

export interface ITrialInstitutionItemCustomViewDataEntryPageSetUpdateModalStateAction {
    type: "ACTION_TRIALINSTITUTIONITEMCUSTOMVIEWDATAENTRY_PAGE_SET_UPDATE_MODAL_STATE",
    updateModalOpen: boolean;
    updateModalCustomDataEntryColumn: Dtos.CustomDataEntryColumn;
    updateModalCollectionInstanceData: Dtos.CollectionInstanceData;
}

/* Action Creators */

export interface ITrialInstitutionItemCustomViewDataEntryPageSetUpdateModalStateActionCreator {
    (
        updateModalOpen: boolean,
        updateModalCustomDataEntryColumn: Dtos.CustomDataEntryColumn,
        updateModalCollectionInstanceData: Dtos.CollectionInstanceData
    ): ITrialInstitutionItemCustomViewDataEntryPageSetUpdateModalStateAction;
}


/* Final Export of actions */
export type TrialInstitutionItemCustomViewDataEntryPageAction =
    ITrialInstitutionItemCustomViewDataEntryPageSetUpdateModalStateAction
